import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-void flex items-center justify-center">
        <div className="font-mono-tech text-[11px] uppercase tracking-widest text-cyan-electric animate-pulse">
          verifying signal...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") {
    return <Navigate to="/console" replace />;
  }
  return children;
}

export default AdminRoute;
